"use client";
import {
  slider_default
} from "./chunk-O6IB4TCE.mjs";
import "./chunk-47QEQS7H.mjs";
import "./chunk-4TRUIEJG.mjs";
import {
  useSlider
} from "./chunk-XHXFV6S5.mjs";
export {
  slider_default as Slider,
  useSlider
};
